<template>
  <transition name="FadeIn">
    <div
      class="Form"
      v-if="forms.requestHelpForm.opened"
      @click.self="
        managePopupState({ popup: 'requestHelpForm', _state: false })
      "
    >
      <div class="Form__inner">
        <div
          class="Form__close"
          @click="managePopupState({ popup: 'requestHelpForm', _state: false })"
        >
          <span>&times;</span>
        </div>
        <div class="Form__caption">
          <h3>{{ $t("HELP_CENTER") }}</h3>
          <i18n tag="p" path="VUE.ABOUT&FORM">
            <template #strong>
              <strong>{{ $t("HELP_CENTER") }}</strong>
            </template>
          </i18n>
          <i18n tag="p" path="VUE.FORM_AGREEMENT">
            <template #link>
              <a href="https://helpcenter.life">{{ $t("HELP_CENTER") }}</a>
            </template>
          </i18n>
        </div>
        <form
          class="Form__data"
          name="requestHelpForm"
          ref="requestHelpForm"
          novalidate
        >
          <div
            class="Form__input"
            :class="{
              _error: $v.author.$dirty && !$v.author.required,
              _success: $v.author.$dirty && $v.author.required
            }"
          >
            <input
              v-model.trim="author"
              type="text"
              :placeholder="$t('NAME')"
              name="author"
              required
            />
            <div
              class="Form__input_error"
              v-if="$v.author.$dirty && !$v.author.required"
            >
              <span>{{ $t("REQUIRED_FIELD") }}</span>
            </div>
          </div>

          <div
            class="Form__input"
            :class="{
              _error: $v.city.$dirty && !$v.city.required,
              _success: $v.city.$dirty && $v.city.required
            }"
          >
            <input
              v-model.trim="city"
              type="text"
              :placeholder="$t('REGION')"
              name="city"
              required
            />
            <div
              class="Form__input_error"
              v-if="$v.city.$dirty && !$v.city.required"
            >
              <span>{{ $t("REQUIRED_FIELD") }}</span>
            </div>
          </div>

          <div
            class="Form__input"
            :class="{
              _error: $v.text.$dirty && !$v.text.required,
              _success: $v.text.$dirty && $v.text.required
            }"
          >
            <textarea
              v-model.trim="text"
              :placeholder="$t('TEXT')"
              name="text"
              required
            ></textarea>
            <div
              class="Form__input_error"
              v-if="$v.text.$dirty && !$v.text.required"
            >
              <span>{{ $t("REQUIRED_FIELD") }}</span>
            </div>
          </div>

          <div
            class="Form__input"
            :class="{
              _error: $v.number.$dirty && !$v.number.required,
              _success: $v.number.$dirty && $v.number.required
            }"
          >
            <input
              v-model.trim="number"
              type="tel"
              :placeholder="$t('PHONE')"
              name="number"
              ref="number"
              v-mask="[$route.meta.mask]"
              required
            />
            <div
              class="Form__input_error"
              v-if="$v.number.$dirty && !$v.number.required"
            >
              <span>{{ $t("REQUIRED_FIELD") }}</span>
            </div>
          </div>

          <div
            class="Form__input"
            :class="{
              _error: $v.contact_types.$dirty && !$v.contact_types.required,
              _success: $v.contact_types.$dirty && $v.contact_types.required
            }"
          >
            <p class="Form__input_caption">{{ $t("CONTACT_TYPE_LABEL") }}</p>
            <div class="Form__checkbox">
              <label for="Телефон">
                <input
                  id="Телефон"
                  value="1"
                  type="checkbox"
                  v-model="contact_types"
                />
                <span>{{ $t("PHONE") }}</span>
              </label>
              <label for="WhatsApp">
                <input
                  id="WhatsApp"
                  value="2"
                  type="checkbox"
                  v-model="contact_types"
                />
                <span>WhatsApp</span>
              </label>
              <label for="Telegram">
                <input
                  id="Telegram"
                  value="3"
                  type="checkbox"
                  v-model="contact_types"
                />
                <span>Telegram</span>
              </label>
              <label for="FacebookM">
                <input
                  id="FacebookM"
                  value="4"
                  type="checkbox"
                  v-model="contact_types"
                />
                <span>Facebook Messenger</span>
              </label>
              <label for="Viber">
                <input
                  id="Viber"
                  value="5"
                  type="checkbox"
                  v-model="contact_types"
                />
                <span>Viber</span>
              </label>
              <label for="Line">
                <input
                  id="Line"
                  value="6"
                  type="checkbox"
                  v-model="contact_types"
                />
                <span>Line</span>
              </label>
            </div>
            <div
              class="Form__input_error"
              v-if="$v.contact_types.$dirty && !$v.contact_types.required"
            >
              <span>{{ $t("CHOOSE_FROM_LIST") }}</span>
            </div>
          </div>

          <div class="Form__input">
            <textarea
              v-model.trim="private_text"
              :placeholder="$t('PRIVATE_TEXT')"
              name="private_text"
            ></textarea>
          </div>

          <div class="Form__input">
            <div class="Form__checkbox">
              <label for="Agreement">
                <input id="Agreement" type="checkbox" v-model="agree" />
                <span>{{ $t("IS_ACCEPT_RULES") }}</span>
              </label>
            </div>
            <div
              class="Form__input_error"
              v-if="$v.agree.$dirty && !$v.agree.checked"
            >
              <span>{{ $t("NEED_REQUIRED_FIELDS") }}</span>
            </div>
          </div>

          <div class="Form__messages">
            <div
              :class="{ success: response.success, error: response.error }"
              v-if="response.text"
            >
              <span>{{ response.text }}</span>
            </div>
          </div>

          <div class="Form__submit" @click.prevent="submitHundler()">
            <button
              :disabled="disabled"
              type="submit"
              class="Form__button button button_primary"
            >
              <span>{{ $t("SEND") }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";
import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
  name: "RequestHelpForm",
  data: () => ({
    author: "",
    city: "",
    text: "",
    number: "",
    private_text: "",
    contact_types: [],
    agree: false,
    disabled: false,
    response: {
      text: null,
      error: null,
      success: null
    }
  }),
  methods: {
    ...mapMutations(["managePopupState"]),
    ...mapActions(["requestNewPost"]),
    async submitHundler() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.disabled = true;

      await this.requestNewPost({
        API: this.$route.meta.API,
        data: {
          region: this.city,
          text: this.text,
          private_text: this.private_text,
          author_name: this.author,
          author_phone: this.number,
          contact_types: this.contact_types
        }
      })
        .then(
          response => (
            response.status == 200
              ? ((this.response.text =
                  "Спасибо за заявку! Мы обязательно свяжемся с Вами!"),
                (this.response.success = true))
              : ((this.response.text =
                  "Извините, мы не можем принять Вашу заявку"),
                (this.response.error = true)),
            setTimeout(() => {
              this.response.text = null;
              this.managePopupState({
                popup: "requestHelpForm",
                _state: false
              });
            }, 3000)
          )
        )
        .catch(
          () => (
            ((this.response.text =
              "Произошла внутренняя ошибка. Пожалуйста, оставьте заявку позже."),
            (this.response.error = true)),
            setTimeout(() => {
              this.response.text = null;
              this.managePopupState({
                popup: "requestHelpForm",
                _state: false
              });
            }, 3000)
          )
        )
        .finally(() => {
          this.author = this.city = this.text = this.number = this.private_text = this.contact_types = this.agree = null;
          this.disabled = false;
        });
    }
  },
  computed: {
    ...mapGetters(["forms"]),
    url: () => document.URL,
    websiteName() {
      return this.$route.meta.description.websiteName;
    }
  },
  validations: {
    author: { required },
    city: { required },
    text: { required },
    number: { required, minLength: minLength(11) },
    contact_types: { required },
    agree: { checked: agree => agree }
  },
  directives: { mask }
};
</script>
